const textFieldLogin = {
  password: 'Contraseña'
};

export default textFieldLogin;
